<template>
  <button
    @click="click"
    type="button"
    class="tw-underline hover:tw-text-highlight-text-medium"
    :data-test="testId"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "BtnLink",
  emits: ["click"],
  props: {
    testId: {
      type: String,
      default: "btn-link",
    },
  },
  setup(props, { emit }) {
    const click = (e) => emit("click", e);

    return { click };
  },
};
</script>
